import axios from "@/services/middleware/client";
import type { ManualPixel } from "@/types/model/ManualPixels";
import type { AdplatformLinkedAccountsResponse } from "@/types/api/response/AdplatformResponses";

export function getChannelsLinks(): Promise<AdplatformLinkedAccountsResponse | void> {
  return axios
    .get("/platform/links")
    .then((res) => res.data as AdplatformLinkedAccountsResponse)
    .catch((error) => {
      console.error("axios error", error);
    });
}

export function channelSync(
  link_id: string | number
): Promise<Record<string, unknown> | void> {
  return axios
    .post(`/platform/sync?id=${link_id}`)
    .then((res) => res.data as Record<string, unknown>)
    .catch((error) => {
      console.error("axios error", error);
    });
}

export function channelUnlink(
  link_id: string | number
): Promise<Record<string, unknown> | void> {
  return axios
    .post(`/platform/unlink?id=${link_id}`)
    .then((res) => res.data as Record<string, unknown>)
    .catch((error) => {
      console.error("axios error", error);
    });
}

export function toggleExclusions(
  link_id: string | number,
  enabled: boolean
): Promise<void> {
  return axios
    .patch(`/platform/pixels/${link_id}`, { enabled })
    .then((res) => res.data)
    .catch((error) => {
      console.error("axios error", error);
    });
}

export function getManualPixels(): Promise<ManualPixel[]> {
  return axios
    .get("/platform/manual-pixels")
    .then((res) => res.data)
    .catch((error) => {
      console.error("axios error", error);
      throw error;
    });
}

export function addManualPixel(id: string, platform: string): Promise<void> {
  return axios
    .put(`/platform/manual-pixels?id=${id}&platform=${platform}`)
    .then((res) => res.data)
    .catch((error) => {
      console.error("axios error", error);
      throw error;
    });
}

export function deleteManualPixel(id: string, platform: string): Promise<void> {
  return axios
    .delete(`/platform/manual-pixels?id=${id}&platform=${platform}`)
    .then((res) => res.data)
    .catch((error) => {
      console.error("axios error", error);
      throw error;
    });
}
